const STRINGS = {
  select_size: {
    sv: 'Välj storlek',
    en: 'Select size',
    fi: 'Valitse koko',
    da: 'Vælg størrelse',
    no: 'Velg størrelse',
    de: 'Größe wählen',
    fr: 'Choisir la taille',
    es: 'Elegir talla',
    it: 'Scegli la taglia',
    nl: 'Kies maat',
  },
  view_product: {
    sv: 'Se produkt',
    en: 'View product',
    fi: 'Näytä tuote',
    da: 'Se produkt',
    no: 'Se produkt',
    de: 'Produkt ansehen',
    fr: 'Voir le produit',
    es: 'Ver producto',
    it: 'Vedi prodotto',
    nl: 'Bekijk product',
  },
  show_more: {
    sv: 'Visa fler',
    en: 'Show more',
    fi: 'Näytä lisää',
    da: 'Vis flere',
    no: 'Vis flere',
    de: 'Mehr anzeigen',
    fr: 'Afficher plus',
    es: 'Mostrar más',
    it: 'Mostra altri',
    nl: 'Meer tonen',
  },
  show_less: {
    sv: 'Visa färre',
    en: 'Show fewer',
    fi: 'Näytä vähemmän',
    da: 'Vis færre',
    no: 'Vis færre',
    de: 'Weniger anzeigen',
    fr: 'Afficher moins',
    es: 'Mostrar menos',
    it: 'Mostra meno',
    nl: 'Minder tonen',
  },
  size_prefix: {
    sv: 'Stl',
    en: 'Size',
    fi: 'Koko',
    da: 'Str',
    no: 'Str',
    de: 'Größe',
    fr: 'Taille',
    es: 'Talla',
    it: 'Taglia',
    nl: 'Maat',
  },
  outfit_suggestion: {
    sv: 'Outfitförslag',
    en: 'Outfit suggestion',
    fi: 'Asuehdotus',
    da: 'Outfitforslag',
    no: 'Antrekksforslag',
    de: 'Outfit-Vorschlag',
    fr: 'Suggestion de tenue',
    es: 'Sugerencia de outfit',
    it: 'Proposta di outfit',
    nl: 'Outfitsuggestie',
  },
  select: {
    sv: 'Välj',
    en: 'Select',
    fi: 'Valitse',
    da: 'Vælg',
    no: 'Velg',
    de: 'Auswählen',
    fr: 'Sélectionner',
    es: 'Seleccionar',
    it: 'Seleziona',
    nl: 'Selecteer',
  },
  add_to_cart: {
    sv: 'Lägg i varukorg',
    en: 'Add to cart',
    fi: 'Lisää ostoskoriin',
    da: 'Læg i kurv',
    no: 'Legg i handlekurv',
    de: 'In den Warenkorb',
    fr: 'Ajouter au panier',
    es: 'Añadir al carrito',
    it: 'Aggiungi al carrello',
    nl: 'In winkelwagen',
  },
  add: {
    sv: 'Lägg till',
    en: 'Add',
    fi: 'Lisää',
    da: 'Tilføj',
    no: 'Legg til',
    de: 'Hinzufügen',
    fr: 'Ajouter',
    es: 'Añadir',
    it: 'Aggiungi',
    nl: 'Voeg toe',
  },
  idle_warning: {
    sv: 'Chatten har varit inaktiv en stund. Om den förblir inaktiv längre kan du behöva starta en ny chatt för att fortsätta där du slutade.',
    en: 'The chat has been idle for a while. If it stays idle longer, you may need to start a new chat to continue where you left off.',
    fi: 'Keskustelu on ollut hetken käyttämättömänä. Jos se pysyy käyttämättömänä pidempään, sinun on ehkä aloitettava uusi keskustelu jatkaaksesi siitä mihin jäit.',
    da: 'Chatten har været inaktiv et stykke tid. Hvis den forbliver inaktiv længere, skal du muligvis starte en ny chat for at fortsætte, hvor du slap.',
    no: 'Chatten har vært inaktiv en stund. Hvis den forblir inaktiv lenger, må du kanskje starte en ny chat for å fortsette der du slapp.',
    de: 'Der Chat war eine Weile inaktiv. Wenn er länger inaktiv bleibt, müssen Sie möglicherweise einen neuen Chat starten, um dort fortzufahren, wo Sie aufgehört haben.',
    fr: 'La conversation est inactive depuis un moment. Si elle le reste plus longtemps, vous devrez peut-être démarrer une nouvelle conversation pour reprendre où vous en étiez.',
    es: 'El chat ha estado inactivo un rato. Si sigue inactivo más tiempo, puede que necesites iniciar un nuevo chat para continuar donde lo dejaste.',
    it: 'La chat è rimasta inattiva per un po’. Se rimane inattiva più a lungo, potrebbe essere necessario avviare una nuova chat per riprendere da dove eri rimasto.',
    nl: 'De chat is een tijdje inactief geweest. Als dat langer duurt, moet je mogelijk een nieuwe chat starten om verder te gaan waar je was gebleven.',
  },
  idle_timeout: {
    sv: 'Chatten har varit inaktiv i 20 minuter. För bästa möjliga hjälp behöver vi starta en ny konversation innan vi fortsätter.',
    en: 'The chat has been idle for 20 minutes. For the best help, we need to start a new conversation before continuing.',
    fi: 'Keskustelu on ollut käyttämättömänä 20 minuuttia. Parhaan avun saamiseksi meidän on aloitettava uusi keskustelu ennen jatkamista.',
    da: 'Chatten har været inaktiv i 20 minutter. For den bedste hjælp skal vi starte en ny samtale, før vi fortsætter.',
    no: 'Chatten har vært inaktiv i 20 minutter. For best mulig hjelp må vi starte en ny samtale før vi fortsetter.',
    de: 'Der Chat war 20 Minuten inaktiv. Für die beste Hilfe müssen wir eine neue Unterhaltung beginnen, bevor wir fortfahren.',
    fr: 'La conversation est inactive depuis 20 minutes. Pour une aide optimale, nous devons démarrer une nouvelle conversation avant de continuer.',
    es: 'El chat ha estado inactivo durante 20 minutos. Para una mejor ayuda, debemos iniciar una nueva conversación antes de continuar.',
    it: 'La chat è rimasta inattiva per 20 minuti. Per un aiuto ottimale, dobbiamo iniziare una nuova conversazione prima di continuare.',
    nl: 'De chat is 20 minuten inactief geweest. Voor de beste hulp moeten we een nieuw gesprek starten voordat we doorgaan.',
  },
  start_new_chat: {
    sv: 'Starta ny chatt',
    en: 'Start new chat',
    fi: 'Aloita uusi keskustelu',
    da: 'Start ny chat',
    no: 'Start ny chat',
    de: 'Neuen Chat starten',
    fr: 'Démarrer une nouvelle conversation',
    es: 'Iniciar nuevo chat',
    it: 'Avvia una nuova chat',
    nl: 'Nieuwe chat starten',
  },
  chat_closed: {
    sv: 'Chatten är avslutad. Starta en ny chatt om du har fler frågor.',
    en: 'This chat is closed. Start a new chat if you have more questions.',
    fi: 'Chat on päättynyt. Aloita uusi keskustelu, jos sinulla on lisää kysymyksiä.',
    da: 'Chatten er afsluttet. Start en ny chat, hvis du har flere spørgsmål.',
    no: 'Chatten er avsluttet. Start en ny chat om du har flere spørsmål.',
    de: 'Dieser Chat ist beendet. Starten Sie einen neuen Chat, wenn Sie weitere Fragen haben.',
    fr: 'Ce chat est terminé. Démarrez un nouveau chat si vous avez d’autres questions.',
    es: 'Este chat ha finalizado. Inicia un nuevo chat si tienes más preguntas.',
    it: 'Questa chat è terminata. Avvia una nuova chat se hai altre domande.',
    nl: 'Deze chat is beëindigd. Start een nieuwe chat als je meer vragen hebt.',
  },

  // --- AI try-on ---------------------------------------------------------
  // Try-on byggdes helt utanför i18n: ~87 hårdkodade svenska strängar i fem
  // komponenter. En dansk kund fick svensk text, inklusive SAMTYCKESTEXTEN.
  // OBS: t() faller tillbaka på SVENSKA, inte engelska — en nyckel utan alla
  // tio språk visar alltså svenska tyst. Alla nycklar måste vara kompletta.
  try_on_button: {
    sv: 'Prova med AI', en: 'Try with AI', fi: 'Kokeile tekoälyllä', da: 'Prøv med AI',
    no: 'Prøv med AI', de: 'Mit KI anprobieren', fr: 'Essayer avec l’IA',
    es: 'Probar con IA', it: 'Prova con l’IA', nl: 'Pas met AI',
  },
  try_on_title: {
    sv: 'Prova plagget med AI', en: 'Try the garment with AI',
    fi: 'Kokeile vaatetta tekoälyllä', da: 'Prøv tøjet med AI',
    no: 'Prøv plagget med AI', de: 'Kleidungsstück mit KI anprobieren',
    fr: 'Essayez le vêtement avec l’IA', es: 'Prueba la prenda con IA',
    it: 'Prova il capo con l’IA', nl: 'Pas het kledingstuk met AI',
  },
  try_on_continue: {
    sv: 'Fortsätt', en: 'Continue', fi: 'Jatka', da: 'Fortsæt', no: 'Fortsett',
    de: 'Weiter', fr: 'Continuer', es: 'Continuar', it: 'Continua', nl: 'Doorgaan',
  },
  try_on_start: {
    sv: 'Starta AI-preview', en: 'Start AI preview', fi: 'Aloita tekoälyesikatselu',
    da: 'Start AI-preview', no: 'Start AI-forhåndsvisning', de: 'KI-Vorschau starten',
    fr: 'Lancer l’aperçu IA', es: 'Iniciar vista previa IA',
    it: 'Avvia anteprima IA', nl: 'Start AI-preview',
  },
  try_on_uploading: {
    sv: 'Laddar upp…', en: 'Uploading…', fi: 'Ladataan…', da: 'Uploader…',
    no: 'Laster opp…', de: 'Wird hochgeladen…', fr: 'Téléversement…',
    es: 'Subiendo…', it: 'Caricamento…', nl: 'Uploaden…',
  },
  try_on_your_photo: {
    sv: 'Din helkroppsbild', en: 'Your full-body photo', fi: 'Koko vartalon kuvasi',
    da: 'Dit helkropsbillede', no: 'Ditt helkroppsbilde', de: 'Dein Ganzkörperfoto',
    fr: 'Votre photo en pied', es: 'Tu foto de cuerpo entero',
    it: 'La tua foto a figura intera', nl: 'Je volledige lichaamsfoto',
  },
  try_on_selected_photo: {
    sv: 'Vald helkroppsbild', en: 'Selected full-body photo', fi: 'Valittu koko vartalon kuva',
    da: 'Valgt helkropsbillede', no: 'Valgt helkroppsbilde', de: 'Ausgewähltes Ganzkörperfoto',
    fr: 'Photo en pied sélectionnée', es: 'Foto de cuerpo entero seleccionada',
    it: 'Foto a figura intera selezionata', nl: 'Geselecteerde volledige lichaamsfoto',
  },
  try_on_retry: {
    sv: 'Prova igen', en: 'Try again', fi: 'Yritä uudelleen', da: 'Prøv igen',
    no: 'Prøv igjen', de: 'Erneut versuchen', fr: 'Réessayer',
    es: 'Inténtalo de nuevo', it: 'Riprova', nl: 'Probeer opnieuw',
  },
  try_on_new_photo: {
    sv: 'Prova med ny bild', en: 'Try a new photo', fi: 'Kokeile uutta kuvaa',
    da: 'Prøv med nyt billede', no: 'Prøv med nytt bilde', de: 'Neues Foto verwenden',
    fr: 'Essayer une autre photo', es: 'Probar con otra foto',
    it: 'Prova con un’altra foto', nl: 'Probeer een nieuwe foto',
  },
  try_on_delete_now: {
    sv: 'Radera min bild nu', en: 'Delete my photo now', fi: 'Poista kuvani nyt',
    da: 'Slet mit billede nu', no: 'Slett bildet mitt nå', de: 'Mein Foto jetzt löschen',
    fr: 'Supprimer ma photo maintenant', es: 'Eliminar mi foto ahora',
    it: 'Elimina la mia foto ora', nl: 'Verwijder mijn foto nu',
  },
  try_on_close: {
    sv: 'Stäng', en: 'Close', fi: 'Sulje', da: 'Luk', no: 'Lukk',
    de: 'Schließen', fr: 'Fermer', es: 'Cerrar', it: 'Chiudi', nl: 'Sluiten',
  },
  try_on_result_title: {
    sv: 'Din AI Look Preview', en: 'Your AI Look Preview', fi: 'AI Look Preview -kuvasi',
    da: 'Din AI Look Preview', no: 'Din AI Look Preview', de: 'Deine AI Look Preview',
    fr: 'Votre AI Look Preview', es: 'Tu AI Look Preview',
    it: 'La tua AI Look Preview', nl: 'Jouw AI Look Preview',
  },
  try_on_switch_garment: {
    sv: 'Byt plagg — från din sökning', en: 'Switch garment — from your search',
    fi: 'Vaihda vaatetta — hausta', da: 'Skift tøj — fra din søgning',
    no: 'Bytt plagg — fra søket ditt', de: 'Kleidungsstück wechseln — aus deiner Suche',
    fr: 'Changer de vêtement — depuis votre recherche',
    es: 'Cambiar prenda — de tu búsqueda',
    it: 'Cambia capo — dalla tua ricerca', nl: 'Wissel kledingstuk — uit je zoekopdracht',
  },
  try_on_error_title: {
    sv: 'Det gick inte att skapa preview', en: 'Could not create the preview',
    fi: 'Esikatselua ei voitu luoda', da: 'Kunne ikke oprette preview',
    no: 'Kunne ikke lage forhåndsvisning', de: 'Vorschau konnte nicht erstellt werden',
    fr: 'Impossible de créer l’aperçu', es: 'No se pudo crear la vista previa',
    it: 'Impossibile creare l’anteprima', nl: 'Kon de preview niet maken',
  },
  try_on_phase_analyzing: {
    sv: 'Analyserar din bild…', en: 'Analysing your photo…', fi: 'Analysoidaan kuvaasi…',
    da: 'Analyserer dit billede…', no: 'Analyserer bildet ditt…',
    de: 'Dein Foto wird analysiert…', fr: 'Analyse de votre photo…',
    es: 'Analizando tu foto…', it: 'Analisi della tua foto…',
    nl: 'Je foto wordt geanalyseerd…',
  },
  try_on_phase_fitting: {
    sv: 'Passar in plagget…', en: 'Fitting the garment…', fi: 'Sovitetaan vaatetta…',
    da: 'Tilpasser tøjet…', no: 'Tilpasser plagget…',
    de: 'Kleidungsstück wird angepasst…', fr: 'Ajustement du vêtement…',
    es: 'Ajustando la prenda…', it: 'Adattamento del capo…',
    nl: 'Kledingstuk wordt gepast…',
  },
  try_on_phase_rendering: {
    sv: 'Renderar din look…', en: 'Rendering your look…', fi: 'Renderöidään ilmettäsi…',
    da: 'Renderer dit look…', no: 'Rendrer looken din…',
    de: 'Dein Look wird gerendert…', fr: 'Rendu de votre look…',
    es: 'Renderizando tu look…', it: 'Rendering del tuo look…',
    nl: 'Je look wordt gerenderd…',
  },
  // ⚠ JURIDIK: samtyckestexterna och lagringsupplysningen nedan är bindande.
  // De ska granskas och godkännas innan produktion (står redan som
  // pre-production-TODO). Översatt-men-ogranskat är ändå bättre än i dag, då
  // en dansk kund får samtyckestexten på svenska.
  try_on_consent_main: {
    sv: 'Jag godkänner att bilden används för att skapa en AI-genererad preview. Bilden raderas automatiskt inom 24 timmar.',
    en: 'I agree that my photo is used to create an AI-generated preview. The photo is deleted automatically within 24 hours.',
    fi: 'Hyväksyn, että kuvaani käytetään tekoälyesikatselun luomiseen. Kuva poistetaan automaattisesti 24 tunnin kuluessa.',
    da: 'Jeg accepterer, at billedet bruges til at skabe en AI-genereret preview. Billedet slettes automatisk inden for 24 timer.',
    no: 'Jeg godtar at bildet brukes til å lage en AI-generert forhåndsvisning. Bildet slettes automatisk innen 24 timer.',
    de: 'Ich stimme zu, dass mein Foto zur Erstellung einer KI-generierten Vorschau verwendet wird. Das Foto wird innerhalb von 24 Stunden automatisch gelöscht.',
    fr: 'J’accepte que ma photo soit utilisée pour créer un aperçu généré par IA. La photo est supprimée automatiquement sous 24 heures.',
    es: 'Acepto que mi foto se use para crear una vista previa generada por IA. La foto se elimina automáticamente en un plazo de 24 horas.',
    it: 'Accetto che la mia foto venga usata per creare un’anteprima generata dall’IA. La foto viene eliminata automaticamente entro 24 ore.',
    nl: 'Ik ga ermee akkoord dat mijn foto wordt gebruikt om een AI-gegenereerde preview te maken. De foto wordt automatisch binnen 24 uur verwijderd.',
  },
  try_on_consent_retention: {
    sv: 'Valfritt: bilden får även sparas i upp till 30 dagar för att förbättra AI-tjänsten.',
    en: 'Optional: the photo may also be stored for up to 30 days to improve the AI service.',
    fi: 'Valinnainen: kuva voidaan säilyttää enintään 30 päivää tekoälypalvelun parantamiseksi.',
    da: 'Valgfrit: billedet må også gemmes i op til 30 dage for at forbedre AI-tjenesten.',
    no: 'Valgfritt: bildet kan også lagres i inntil 30 dager for å forbedre AI-tjenesten.',
    de: 'Optional: Das Foto darf auch bis zu 30 Tage gespeichert werden, um den KI-Dienst zu verbessern.',
    fr: 'Facultatif : la photo peut aussi être conservée jusqu’à 30 jours pour améliorer le service IA.',
    es: 'Opcional: la foto también puede guardarse hasta 30 días para mejorar el servicio de IA.',
    it: 'Facoltativo: la foto può essere conservata fino a 30 giorni per migliorare il servizio IA.',
    nl: 'Optioneel: de foto mag ook tot 30 dagen worden bewaard om de AI-dienst te verbeteren.',
  },
  try_on_disclaimer: {
    sv: 'AI-genererad förhandsvisning — faktisk passform kan skilja sig. Din bild sparas i högst {retention} och raderas därefter automatiskt.',
    en: 'AI-generated preview — the actual fit may differ. Your photo is stored for at most {retention} and is then deleted automatically.',
    fi: 'Tekoälyn luoma esikatselu — todellinen istuvuus voi poiketa. Kuvasi säilytetään enintään {retention} ja poistetaan sen jälkeen automaattisesti.',
    da: 'AI-genereret preview — den faktiske pasform kan afvige. Dit billede gemmes i højst {retention} og slettes derefter automatisk.',
    no: 'AI-generert forhåndsvisning — faktisk passform kan avvike. Bildet ditt lagres i høyst {retention} og slettes deretter automatisk.',
    de: 'KI-generierte Vorschau — die tatsächliche Passform kann abweichen. Dein Foto wird höchstens {retention} gespeichert und danach automatisch gelöscht.',
    fr: 'Aperçu généré par IA — la coupe réelle peut différer. Votre photo est conservée au maximum {retention} puis supprimée automatiquement.',
    es: 'Vista previa generada por IA: el ajuste real puede variar. Tu foto se guarda como máximo {retention} y luego se elimina automáticamente.',
    it: 'Anteprima generata dall’IA — la vestibilità reale può differire. La tua foto viene conservata al massimo {retention} e poi eliminata automaticamente.',
    nl: 'AI-gegenereerde preview — de werkelijke pasvorm kan afwijken. Je foto wordt maximaal {retention} bewaard en daarna automatisch verwijderd.',
  },
  // Separata nycklar, inte hopfogade fragment: ordföljden skiljer sig mellan
  // språken och "sparas i högst " + "30 dagar" går inte att översätta bitvis.
  try_on_retention_30d: {
    sv: '30 dagar', en: '30 days', fi: '30 päivää', da: '30 dage', no: '30 dager',
    de: '30 Tage', fr: '30 jours', es: '30 días', it: '30 giorni', nl: '30 dagen',
  },
  try_on_retention_24h: {
    sv: '24 timmar', en: '24 hours', fi: '24 tuntia', da: '24 timer', no: '24 timer',
    de: '24 Stunden', fr: '24 heures', es: '24 horas', it: '24 ore', nl: '24 uur',
  },
  try_on_generating: {
    sv: 'AI provar {product} — det kan ta två till tre minuter.',
    en: 'AI is trying on {product} — this can take two to three minutes.',
    fi: 'Tekoäly sovittaa tuotetta {product} — tämä voi kestää 2–3 minuuttia.',
    da: 'AI prøver {product} — det kan tage to til tre minutter.',
    no: 'AI prøver {product} — det kan ta to til tre minutter.',
    de: 'Die KI probiert {product} an — das kann zwei bis drei Minuten dauern.',
    fr: 'L’IA essaie {product} — cela peut prendre deux à trois minutes.',
    es: 'La IA está probando {product}: puede tardar entre dos y tres minutos.',
    it: 'L’IA sta provando {product} — può richiedere due o tre minuti.',
    nl: 'AI past {product} — dit kan twee tot drie minuten duren.',
  },
  try_on_switch_hint: {
    sv: '✓ = redan genererad (visas direkt) · nytt plagg tar två till tre minuter',
    en: '✓ = already generated (shown instantly) · a new garment takes two to three minutes',
    fi: '✓ = jo luotu (näkyy heti) · uusi vaate kestää 2–3 minuuttia',
    da: '✓ = allerede genereret (vises straks) · nyt tøj tager to til tre minutter',
    no: '✓ = allerede generert (vises umiddelbart) · nytt plagg tar to til tre minutter',
    de: '✓ = bereits erstellt (sofort sichtbar) · ein neues Kleidungsstück dauert zwei bis drei Minuten',
    fr: '✓ = déjà généré (affiché immédiatement) · un nouveau vêtement prend deux à trois minutes',
    es: '✓ = ya generado (se muestra al instante) · una prenda nueva tarda de dos a tres minutos',
    it: '✓ = già generato (mostrato subito) · un nuovo capo richiede due o tre minuti',
    nl: '✓ = al gegenereerd (direct zichtbaar) · een nieuw kledingstuk duurt twee tot drie minuten',
  },
  try_on_login_required: {
    sv: 'AI-preview är bara tillgänglig när du är inloggad. Logga in och försök igen.',
    en: 'AI preview is only available when you are signed in. Sign in and try again.',
    fi: 'Tekoälyesikatselu on käytettävissä vain kirjautuneena. Kirjaudu sisään ja yritä uudelleen.',
    da: 'AI-preview er kun tilgængelig, når du er logget ind. Log ind, og prøv igen.',
    no: 'AI-forhåndsvisning er bare tilgjengelig når du er logget inn. Logg inn og prøv igjen.',
    de: 'Die KI-Vorschau ist nur angemeldet verfügbar. Melde dich an und versuche es erneut.',
    fr: 'L’aperçu IA n’est disponible qu’une fois connecté. Connectez-vous et réessayez.',
    es: 'La vista previa con IA solo está disponible si has iniciado sesión. Inicia sesión e inténtalo de nuevo.',
    it: 'L’anteprima IA è disponibile solo se hai effettuato l’accesso. Accedi e riprova.',
    nl: 'AI-preview is alleen beschikbaar als je bent ingelogd. Log in en probeer opnieuw.',
  },
  try_on_quota_exceeded: {
    sv: 'Du har använt veckans AI-previews. Du kan prova igen om några dagar.',
    en: 'You have used this week’s AI previews. You can try again in a few days.',
    fi: 'Olet käyttänyt tämän viikon tekoälyesikatselut. Voit yrittää uudelleen muutaman päivän kuluttua.',
    da: 'Du har brugt ugens AI-previews. Du kan prøve igen om et par dage.',
    no: 'Du har brukt ukens AI-forhåndsvisninger. Du kan prøve igjen om noen dager.',
    de: 'Du hast die KI-Vorschauen dieser Woche aufgebraucht. In ein paar Tagen kannst du es erneut versuchen.',
    fr: 'Vous avez utilisé les aperçus IA de la semaine. Vous pourrez réessayer dans quelques jours.',
    es: 'Has usado las vistas previas con IA de esta semana. Podrás volver a intentarlo en unos días.',
    it: 'Hai usato le anteprime IA di questa settimana. Potrai riprovare tra qualche giorno.',
    nl: 'Je hebt de AI-previews van deze week gebruikt. Over een paar dagen kun je het opnieuw proberen.',
  },
  try_on_upload_expired: {
    sv: 'Din uppladdade bild har gått ut. Ladda upp den igen.',
    en: 'Your uploaded photo has expired. Please upload it again.',
    fi: 'Lataamasi kuva on vanhentunut. Lataa se uudelleen.',
    da: 'Dit uploadede billede er udløbet. Upload det igen.',
    no: 'Det opplastede bildet ditt har utløpt. Last det opp på nytt.',
    de: 'Dein hochgeladenes Foto ist abgelaufen. Lade es erneut hoch.',
    fr: 'Votre photo téléversée a expiré. Téléversez-la à nouveau.',
    es: 'Tu foto subida ha caducado. Vuelve a subirla.',
    it: 'La foto caricata è scaduta. Caricala di nuovo.',
    nl: 'Je geüploade foto is verlopen. Upload hem opnieuw.',
  },
  try_on_upload_error: {
    sv: 'Något gick fel när vi laddade upp din bild. Kontrollera bilden och försök igen.',
    en: 'Something went wrong while uploading your photo. Check the photo and try again.',
    fi: 'Kuvan lataamisessa tapahtui virhe. Tarkista kuva ja yritä uudelleen.',
    da: 'Noget gik galt, da vi uploadede dit billede. Tjek billedet, og prøv igen.',
    no: 'Noe gikk galt da vi lastet opp bildet ditt. Sjekk bildet og prøv igjen.',
    de: 'Beim Hochladen deines Fotos ist etwas schiefgegangen. Prüfe das Foto und versuche es erneut.',
    fr: 'Une erreur est survenue lors du téléversement de votre photo. Vérifiez-la et réessayez.',
    es: 'Algo salió mal al subir tu foto. Revisa la foto e inténtalo de nuevo.',
    it: 'Qualcosa è andato storto durante il caricamento della foto. Controllala e riprova.',
    nl: 'Er ging iets mis bij het uploaden van je foto. Controleer de foto en probeer opnieuw.',
  },
  try_on_start_error: {
    sv: 'Något gick fel när vi startade din AI-preview. Kontrollera bilden och försök igen.',
    en: 'Something went wrong starting your AI preview. Check the photo and try again.',
    fi: 'Tekoälyesikatselun aloittamisessa tapahtui virhe. Tarkista kuva ja yritä uudelleen.',
    da: 'Noget gik galt, da vi startede din AI-preview. Tjek billedet, og prøv igen.',
    no: 'Noe gikk galt da vi startet AI-forhåndsvisningen. Sjekk bildet og prøv igjen.',
    de: 'Beim Starten deiner KI-Vorschau ist etwas schiefgegangen. Prüfe das Foto und versuche es erneut.',
    fr: 'Une erreur est survenue au lancement de votre aperçu IA. Vérifiez la photo et réessayez.',
    es: 'Algo salió mal al iniciar tu vista previa con IA. Revisa la foto e inténtalo de nuevo.',
    it: 'Qualcosa è andato storto avviando l’anteprima IA. Controlla la foto e riprova.',
    nl: 'Er ging iets mis bij het starten van je AI-preview. Controleer de foto en probeer opnieuw.',
  },
  try_on_status_error: {
    sv: 'Kunde inte hämta status för din AI-preview. Försök igen.',
    en: 'Could not fetch the status of your AI preview. Please try again.',
    fi: 'Tekoälyesikatselun tilaa ei voitu hakea. Yritä uudelleen.',
    da: 'Kunne ikke hente status for din AI-preview. Prøv igen.',
    no: 'Kunne ikke hente status for AI-forhåndsvisningen. Prøv igjen.',
    de: 'Der Status deiner KI-Vorschau konnte nicht abgerufen werden. Versuche es erneut.',
    fr: 'Impossible de récupérer l’état de votre aperçu IA. Réessayez.',
    es: 'No se pudo obtener el estado de tu vista previa con IA. Inténtalo de nuevo.',
    it: 'Impossibile recuperare lo stato dell’anteprima IA. Riprova.',
    nl: 'Kon de status van je AI-preview niet ophalen. Probeer opnieuw.',
  },
  // Produktnamn — samma på alla språk med flit.
  try_on_eyebrow: {
    sv: 'AI Look Preview', en: 'AI Look Preview', fi: 'AI Look Preview', da: 'AI Look Preview',
    no: 'AI Look Preview', de: 'AI Look Preview', fr: 'AI Look Preview',
    es: 'AI Look Preview', it: 'AI Look Preview', nl: 'AI Look Preview',
  },
  try_on_size_label: {
    sv: 'Storlek', en: 'Size', fi: 'Koko', da: 'Størrelse', no: 'Størrelse',
    de: 'Größe', fr: 'Taille', es: 'Talla', it: 'Taglia', nl: 'Maat',
  },
  try_on_wishlist_add: {
    sv: 'Spara i önskelistan', en: 'Save to wishlist', fi: 'Tallenna toivelistalle',
    da: 'Gem på ønskelisten', no: 'Lagre i ønskelisten', de: 'Auf die Wunschliste',
    fr: 'Ajouter à la liste d’envies', es: 'Guardar en la lista de deseos',
    it: 'Salva nella lista dei desideri', nl: 'Bewaar in verlanglijst',
  },
  try_on_wishlist_saved: {
    sv: 'Sparad i önskelistan', en: 'Saved to wishlist', fi: 'Tallennettu toivelistalle',
    da: 'Gemt på ønskelisten', no: 'Lagret i ønskelisten', de: 'Auf der Wunschliste',
    fr: 'Ajouté à la liste d’envies', es: 'Guardado en la lista de deseos',
    it: 'Salvato nella lista dei desideri', nl: 'Bewaard in verlanglijst',
  },
  try_on_alt_your_photo: {
    sv: 'Din bild', en: 'Your photo', fi: 'Kuvasi', da: 'Dit billede', no: 'Bildet ditt',
    de: 'Dein Foto', fr: 'Votre photo', es: 'Tu foto', it: 'La tua foto', nl: 'Je foto',
  },
  try_on_alt_result: {
    sv: 'AI-genererad preview', en: 'AI-generated preview', fi: 'Tekoälyn luoma esikatselu',
    da: 'AI-genereret preview', no: 'AI-generert forhåndsvisning', de: 'KI-generierte Vorschau',
    fr: 'Aperçu généré par IA', es: 'Vista previa generada por IA',
    it: 'Anteprima generata dall’IA', nl: 'AI-gegenereerde preview',
  },
  try_on_details_title: {
    sv: 'Produktbeskrivning', en: 'Product description', fi: 'Tuotekuvaus',
    da: 'Produktbeskrivelse', no: 'Produktbeskrivelse', de: 'Produktbeschreibung',
    fr: 'Description du produit', es: 'Descripción del producto',
    it: 'Descrizione del prodotto', nl: 'Productbeschrijving',
  },
  try_on_details_loading: {
    sv: 'Hämtar produktinformation…', en: 'Loading product information…',
    fi: 'Haetaan tuotetietoja…', da: 'Henter produktinformation…',
    no: 'Henter produktinformasjon…', de: 'Produktinformationen werden geladen…',
    fr: 'Chargement des informations produit…', es: 'Cargando información del producto…',
    it: 'Caricamento informazioni prodotto…', nl: 'Productinformatie laden…',
  },
  try_on_details_error: {
    sv: 'Produktinformationen kunde inte hämtas just nu.',
    en: 'Product information could not be loaded right now.',
    fi: 'Tuotetietoja ei voitu hakea juuri nyt.',
    da: 'Produktinformationen kunne ikke hentes lige nu.',
    no: 'Produktinformasjonen kunne ikke hentes nå.',
    de: 'Die Produktinformationen konnten gerade nicht geladen werden.',
    fr: 'Les informations produit n’ont pas pu être chargées pour le moment.',
    es: 'No se pudo cargar la información del producto en este momento.',
    it: 'Non è stato possibile caricare le informazioni sul prodotto in questo momento.',
    nl: 'De productinformatie kon nu niet worden geladen.',
  },
  try_on_material: {
    sv: 'Material', en: 'Material', fi: 'Materiaali', da: 'Materiale', no: 'Materiale',
    de: 'Material', fr: 'Matière', es: 'Material', it: 'Materiale', nl: 'Materiaal',
  },
  try_on_fit: {
    sv: 'Passform', en: 'Fit', fi: 'Istuvuus', da: 'Pasform', no: 'Passform',
    de: 'Passform', fr: 'Coupe', es: 'Corte', it: 'Vestibilità', nl: 'Pasvorm',
  },
  try_on_care: {
    sv: 'Skötselråd', en: 'Care instructions', fi: 'Hoito-ohjeet', da: 'Vaskeanvisning',
    no: 'Vaskeanvisning', de: 'Pflegehinweise', fr: 'Entretien',
    es: 'Cuidados', it: 'Manutenzione', nl: 'Wasvoorschrift',
  },
  try_on_sku: {
    sv: 'Artikelnummer', en: 'Item number', fi: 'Tuotenumero', da: 'Varenummer',
    no: 'Artikkelnummer', de: 'Artikelnummer', fr: 'Référence',
    es: 'Número de artículo', it: 'Codice articolo', nl: 'Artikelnummer',
  },
  try_on_photo_intro: {
    sv: 'Bildkvaliteten avgör resultatet — så här får du bästa AI-preview:',
    en: 'Photo quality decides the result — here is how to get the best AI preview:',
    fi: 'Kuvan laatu ratkaisee lopputuloksen — näin saat parhaan esikatselun:',
    da: 'Billedkvaliteten afgør resultatet — sådan får du den bedste AI-preview:',
    no: 'Bildekvaliteten avgjør resultatet — slik får du best AI-forhåndsvisning:',
    de: 'Die Fotoqualität entscheidet über das Ergebnis — so gelingt die beste KI-Vorschau:',
    fr: 'La qualité de la photo détermine le résultat — voici comment obtenir le meilleur aperçu IA :',
    es: 'La calidad de la foto decide el resultado: así consigues la mejor vista previa con IA:',
    it: 'La qualità della foto determina il risultato — ecco come ottenere la migliore anteprima IA:',
    nl: 'De fotokwaliteit bepaalt het resultaat — zo krijg je de beste AI-preview:',
  },
  try_on_tip_front: {
    sv: 'Stå rakt framifrån', en: 'Face the camera straight on', fi: 'Seiso suoraan edestä',
    da: 'Stå lige forfra', no: 'Stå rett forfra', de: 'Stehe frontal zur Kamera',
    fr: 'Placez-vous bien de face', es: 'Colócate de frente',
    it: 'Mettiti frontalmente', nl: 'Sta recht van voren',
  },
  try_on_tip_full_body: {
    sv: 'Hela kroppen ska synas', en: 'Your whole body should be visible',
    fi: 'Koko vartalon tulee näkyä', da: 'Hele kroppen skal ses',
    no: 'Hele kroppen må synes', de: 'Der ganze Körper muss sichtbar sein',
    fr: 'Tout le corps doit être visible', es: 'Todo el cuerpo debe verse',
    it: 'Tutto il corpo deve essere visibile', nl: 'Je hele lichaam moet zichtbaar zijn',
  },
  try_on_tip_light: {
    sv: 'Bra, jämn belysning', en: 'Good, even lighting', fi: 'Hyvä, tasainen valaistus',
    da: 'God, jævn belysning', no: 'God, jevn belysning', de: 'Gutes, gleichmäßiges Licht',
    fr: 'Un éclairage bon et uniforme', es: 'Buena iluminación uniforme',
    it: 'Illuminazione buona e uniforme', nl: 'Goed, gelijkmatig licht',
  },
  try_on_tip_one_person: {
    sv: 'Endast en person i bild', en: 'Only one person in the photo',
    fi: 'Vain yksi henkilö kuvassa', da: 'Kun én person på billedet',
    no: 'Bare én person i bildet', de: 'Nur eine Person auf dem Foto',
    fr: 'Une seule personne sur la photo', es: 'Solo una persona en la foto',
    it: 'Una sola persona nella foto', nl: 'Slechts één persoon op de foto',
  },
  try_on_tip_tight_clothes: {
    sv: 'Undvik stora, lösa plagg', en: 'Avoid large, loose clothing',
    fi: 'Vältä suuria, väljiä vaatteita', da: 'Undgå store, løse tøjstykker',
    no: 'Unngå store, løse plagg', de: 'Vermeide weite, lockere Kleidung',
    fr: 'Évitez les vêtements amples', es: 'Evita ropa grande y holgada',
    it: 'Evita capi larghi e sformati', nl: 'Vermijd grote, losse kleding',
  },
  try_on_tip_background: {
    sv: 'Så neutral bakgrund som möjligt', en: 'As neutral a background as possible',
    fi: 'Mahdollisimman neutraali tausta', da: 'Så neutral baggrund som muligt',
    no: 'Så nøytral bakgrunn som mulig', de: 'Möglichst neutraler Hintergrund',
    fr: 'Un arrière-plan aussi neutre que possible', es: 'Un fondo lo más neutro posible',
    it: 'Uno sfondo il più neutro possibile', nl: 'Een zo neutraal mogelijke achtergrond',
  },
  try_on_pick_image: {
    sv: 'Klicka för att välja bild', en: 'Click to choose a photo', fi: 'Valitse kuva napsauttamalla',
    da: 'Klik for at vælge billede', no: 'Klikk for å velge bilde', de: 'Zum Foto auswählen klicken',
    fr: 'Cliquez pour choisir une photo', es: 'Haz clic para elegir una foto',
    it: 'Clicca per scegliere una foto', nl: 'Klik om een foto te kiezen',
  },
  try_on_crop_title: {
    sv: 'Placera dig i ramen', en: 'Position yourself in the frame',
    fi: 'Aseta itsesi kehykseen', da: 'Placér dig i rammen',
    no: 'Plasser deg i rammen', de: 'Positioniere dich im Rahmen',
    fr: 'Placez-vous dans le cadre', es: 'Colócate en el marco',
    it: 'Posizionati nel riquadro', nl: 'Plaats jezelf in het kader',
  },
  try_on_crop_help: {
    sv: 'Dra tills ansiktet ligger på ringen. Hela kroppen ska synas.',
    en: 'Drag until your face sits on the ring. Your whole body should be visible.',
    fi: 'Vedä, kunnes kasvosi ovat renkaan kohdalla. Koko kehon tulee näkyä.',
    da: 'Træk, indtil ansigtet ligger på ringen. Hele kroppen skal være synlig.',
    no: 'Dra til ansiktet ligger på ringen. Hele kroppen skal være synlig.',
    de: 'Ziehe, bis dein Gesicht auf dem Ring liegt. Der ganze Körper muss sichtbar sein.',
    fr: 'Faites glisser jusqu’à ce que votre visage soit sur le cercle. Tout le corps doit être visible.',
    es: 'Arrastra hasta que tu cara quede sobre el círculo. Todo el cuerpo debe verse.',
    it: 'Trascina finché il viso si trova sul cerchio. Tutto il corpo deve essere visibile.',
    nl: 'Sleep tot je gezicht op de ring ligt. Je hele lichaam moet zichtbaar zijn.',
  },
  try_on_crop_face_small: {
    sv: 'Bilden har för låg upplösning för ett bra resultat — välj en skarpare bild.',
    en: 'This photo is too low-resolution for a good result — choose a sharper one.',
    fi: 'Kuvan tarkkuus on liian pieni hyvään lopputulokseen — valitse tarkempi kuva.',
    da: 'Billedet har for lav opløsning til et godt resultat — vælg et skarpere.',
    no: 'Bildet har for lav oppløsning til et godt resultat — velg et skarpere.',
    de: 'Dieses Foto hat für ein gutes Ergebnis zu wenig Auflösung — wähle ein schärferes.',
    fr: 'Cette photo est de trop faible résolution pour un bon résultat — choisissez-en une plus nette.',
    es: 'Esta foto tiene una resolución demasiado baja para un buen resultado: elige una más nítida.',
    it: 'Questa foto ha una risoluzione troppo bassa per un buon risultato: scegline una più nitida.',
    nl: 'Deze foto heeft een te lage resolutie voor een goed resultaat — kies een scherpere.',
  },
  try_on_crop_zoom: {
    sv: 'Zooma', en: 'Zoom', fi: 'Zoomaa', da: 'Zoom', no: 'Zoom',
    de: 'Zoomen', fr: 'Zoomer', es: 'Zoom', it: 'Zoom', nl: 'Zoomen',
  },
  try_on_crop_reset: {
    sv: 'Börja om', en: 'Start over', fi: 'Aloita alusta', da: 'Start forfra',
    no: 'Start på nytt', de: 'Neu beginnen', fr: 'Recommencer',
    es: 'Empezar de nuevo', it: 'Ricomincia', nl: 'Opnieuw beginnen',
  },
  try_on_crop_confirm: {
    sv: 'Använd den här bilden', en: 'Use this photo', fi: 'Käytä tätä kuvaa',
    da: 'Brug dette billede', no: 'Bruk dette bildet', de: 'Dieses Foto verwenden',
    fr: 'Utiliser cette photo', es: 'Usar esta foto',
    it: 'Usa questa foto', nl: 'Deze foto gebruiken',
  },
  try_on_crop_change: {
    sv: 'Välj en annan bild', en: 'Choose a different photo', fi: 'Valitse toinen kuva',
    da: 'Vælg et andet billede', no: 'Velg et annet bilde', de: 'Anderes Foto wählen',
    fr: 'Choisir une autre photo', es: 'Elegir otra foto',
    it: 'Scegli un’altra foto', nl: 'Kies een andere foto',
  },
  try_on_crop_failed: {
    sv: 'Bilden kunde inte behandlas. Prova en annan.',
    en: 'The photo could not be processed. Try another one.',
    fi: 'Kuvaa ei voitu käsitellä. Kokeile toista.',
    da: 'Billedet kunne ikke behandles. Prøv et andet.',
    no: 'Bildet kunne ikke behandles. Prøv et annet.',
    de: 'Das Foto konnte nicht verarbeitet werden. Versuche ein anderes.',
    fr: 'La photo n’a pas pu être traitée. Essayez-en une autre.',
    es: 'No se pudo procesar la foto. Prueba con otra.',
    it: 'Non è stato possibile elaborare la foto. Provane un’altra.',
    nl: 'De foto kon niet worden verwerkt. Probeer een andere.',
  },
  try_on_reuse_photo: {
    sv: 'Din senaste bild återanvänds — klicka ovan för att byta.',
    en: 'Your most recent photo is reused — click above to change it.',
    fi: 'Viimeisin kuvasi käytetään uudelleen — vaihda napsauttamalla yllä.',
    da: 'Dit seneste billede genbruges — klik ovenfor for at skifte.',
    no: 'Det siste bildet ditt gjenbrukes — klikk over for å bytte.',
    de: 'Dein letztes Foto wird wiederverwendet — oben klicken zum Ändern.',
    fr: 'Votre dernière photo est réutilisée — cliquez ci-dessus pour la changer.',
    es: 'Se reutiliza tu última foto: haz clic arriba para cambiarla.',
    it: 'La tua ultima foto viene riutilizzata — clicca sopra per cambiarla.',
    nl: 'Je laatste foto wordt hergebruikt — klik hierboven om te wisselen.',
  },
  try_on_selected_file: {
    sv: 'Vald bild:', en: 'Selected photo:', fi: 'Valittu kuva:', da: 'Valgt billede:',
    no: 'Valgt bilde:', de: 'Ausgewähltes Foto:', fr: 'Photo sélectionnée :',
    es: 'Foto seleccionada:', it: 'Foto selezionata:', nl: 'Geselecteerde foto:',
  },
  try_on_file_format: {
    sv: 'Välj en bild i JPG-, PNG- eller WebP-format.',
    en: 'Choose a photo in JPG, PNG or WebP format.',
    fi: 'Valitse kuva JPG-, PNG- tai WebP-muodossa.',
    da: 'Vælg et billede i JPG-, PNG- eller WebP-format.',
    no: 'Velg et bilde i JPG-, PNG- eller WebP-format.',
    de: 'Wähle ein Foto im Format JPG, PNG oder WebP.',
    fr: 'Choisissez une photo au format JPG, PNG ou WebP.',
    es: 'Elige una foto en formato JPG, PNG o WebP.',
    it: 'Scegli una foto in formato JPG, PNG o WebP.',
    nl: 'Kies een foto in JPG-, PNG- of WebP-formaat.',
  },
  try_on_file_too_large: {
    sv: 'Bilden är för stor. Maxstorlek är {size}.',
    en: 'The photo is too large. Maximum size is {size}.',
    fi: 'Kuva on liian suuri. Enimmäiskoko on {size}.',
    da: 'Billedet er for stort. Maksimal størrelse er {size}.',
    no: 'Bildet er for stort. Maksimal størrelse er {size}.',
    de: 'Das Foto ist zu groß. Maximale Größe ist {size}.',
    fr: 'La photo est trop volumineuse. Taille maximale : {size}.',
    es: 'La foto es demasiado grande. El tamaño máximo es {size}.',
    it: 'La foto è troppo grande. Dimensione massima: {size}.',
    nl: 'De foto is te groot. Maximale grootte is {size}.',
  },
  try_on_err_no_person: {
    sv: 'Vi kunde inte hitta en tydlig person i bilden. Prova en helkroppsbild framifrån.',
    en: 'We could not find a clear person in the photo. Try a full-body photo from the front.',
    fi: 'Kuvasta ei löytynyt selkeää henkilöä. Kokeile koko vartalon kuvaa edestä.',
    da: 'Vi kunne ikke finde en tydelig person på billedet. Prøv et helkropsbillede forfra.',
    no: 'Vi fant ingen tydelig person i bildet. Prøv et helkroppsbilde forfra.',
    de: 'Wir konnten keine deutliche Person auf dem Foto erkennen. Versuche ein Ganzkörperfoto von vorne.',
    fr: 'Nous n’avons pas trouvé de personne nette sur la photo. Essayez une photo en pied de face.',
    es: 'No encontramos una persona clara en la foto. Prueba una foto de cuerpo entero de frente.',
    it: 'Non abbiamo trovato una persona nitida nella foto. Prova una foto a figura intera frontale.',
    nl: 'We konden geen duidelijke persoon in de foto vinden. Probeer een volledige lichaamsfoto van voren.',
  },
  try_on_err_multiple_people: {
    sv: 'Bilden verkar innehålla flera personer. Ladda upp en bild med endast dig.',
    en: 'The photo seems to contain several people. Upload a photo with only you in it.',
    fi: 'Kuvassa näyttää olevan useita henkilöitä. Lataa kuva, jossa olet vain sinä.',
    da: 'Billedet ser ud til at indeholde flere personer. Upload et billede med kun dig.',
    no: 'Bildet ser ut til å inneholde flere personer. Last opp et bilde med bare deg.',
    de: 'Auf dem Foto scheinen mehrere Personen zu sein. Lade ein Foto hoch, auf dem nur du zu sehen bist.',
    fr: 'La photo semble contenir plusieurs personnes. Téléversez une photo où vous êtes seul.',
    es: 'La foto parece contener varias personas. Sube una foto en la que solo estés tú.',
    it: 'La foto sembra contenere più persone. Carica una foto in cui ci sei solo tu.',
    nl: 'De foto lijkt meerdere personen te bevatten. Upload een foto met alleen jou.',
  },
  try_on_err_unsupported_product: {
    sv: 'Den här produkten stöds inte ännu. Testa med jackor, skjortor, tröjor eller byxor.',
    en: 'This product is not supported yet. Try jackets, shirts, knitwear or trousers.',
    fi: 'Tätä tuotetta ei vielä tueta. Kokeile takkeja, paitoja, neuleita tai housuja.',
    da: 'Dette produkt understøttes ikke endnu. Prøv jakker, skjorter, strik eller bukser.',
    no: 'Dette produktet støttes ikke ennå. Prøv jakker, skjorter, gensere eller bukser.',
    de: 'Dieses Produkt wird noch nicht unterstützt. Versuche Jacken, Hemden, Strick oder Hosen.',
    fr: 'Ce produit n’est pas encore pris en charge. Essayez vestes, chemises, mailles ou pantalons.',
    es: 'Este producto aún no es compatible. Prueba con chaquetas, camisas, punto o pantalones.',
    it: 'Questo prodotto non è ancora supportato. Prova giacche, camicie, maglieria o pantaloni.',
    nl: 'Dit product wordt nog niet ondersteund. Probeer jassen, overhemden, breigoed of broeken.',
  },
  try_on_err_low_quality: {
    sv: 'Bilden är för låg kvalitet. Prova en skarpare bild med bättre ljus.',
    en: 'The photo quality is too low. Try a sharper photo with better light.',
    fi: 'Kuvan laatu on liian heikko. Kokeile tarkempaa kuvaa paremmassa valossa.',
    da: 'Billedkvaliteten er for lav. Prøv et skarpere billede med bedre lys.',
    no: 'Bildekvaliteten er for lav. Prøv et skarpere bilde med bedre lys.',
    de: 'Die Fotoqualität ist zu niedrig. Versuche ein schärferes Foto mit besserem Licht.',
    fr: 'La qualité de la photo est trop faible. Essayez une photo plus nette avec un meilleur éclairage.',
    es: 'La calidad de la foto es demasiado baja. Prueba una foto más nítida con mejor luz.',
    it: 'La qualità della foto è troppo bassa. Prova una foto più nitida con luce migliore.',
    nl: 'De fotokwaliteit is te laag. Probeer een scherpere foto met beter licht.',
  },
  try_on_err_generation_failed: {
    sv: 'AI-preview kunde inte skapas just nu. Försök igen om en stund.',
    en: 'The AI preview could not be created right now. Please try again shortly.',
    fi: 'Tekoälyesikatselua ei voitu luoda juuri nyt. Yritä hetken kuluttua uudelleen.',
    da: 'AI-preview kunne ikke oprettes lige nu. Prøv igen om lidt.',
    no: 'AI-forhåndsvisningen kunne ikke lages nå. Prøv igjen om litt.',
    de: 'Die KI-Vorschau konnte gerade nicht erstellt werden. Versuche es gleich noch einmal.',
    fr: 'L’aperçu IA n’a pas pu être créé pour le moment. Réessayez dans un instant.',
    es: 'No se pudo crear la vista previa de IA ahora mismo. Inténtalo de nuevo en un momento.',
    it: 'Non è stato possibile creare l’anteprima IA in questo momento. Riprova tra poco.',
    nl: 'De AI-preview kon nu niet worden gemaakt. Probeer het zo opnieuw.',
  },
  try_on_err_content_policy: {
    sv: 'Bilden kunde inte användas enligt våra innehållsregler. Prova en annan bild.',
    en: 'The photo could not be used under our content rules. Try a different photo.',
    fi: 'Kuvaa ei voitu käyttää sisältösääntöjemme mukaan. Kokeile toista kuvaa.',
    da: 'Billedet kunne ikke bruges i henhold til vores indholdsregler. Prøv et andet billede.',
    no: 'Bildet kunne ikke brukes i henhold til innholdsreglene våre. Prøv et annet bilde.',
    de: 'Das Foto konnte nach unseren Inhaltsrichtlinien nicht verwendet werden. Versuche ein anderes Foto.',
    fr: 'La photo n’a pas pu être utilisée selon nos règles de contenu. Essayez une autre photo.',
    es: 'La foto no se pudo usar según nuestras normas de contenido. Prueba con otra foto.',
    it: 'La foto non è utilizzabile secondo le nostre regole sui contenuti. Prova un’altra foto.',
    nl: 'De foto kon niet worden gebruikt volgens onze inhoudsregels. Probeer een andere foto.',
  },
  try_on_err_face_preserve: {
    sv: 'Vi kunde inte behålla ditt ansikte oförändrat i resultatet. Prova en bild rakt framifrån där hela överkroppen syns.',
    en: 'We could not keep your face unchanged in the result. Try a photo straight from the front showing your whole upper body.',
    fi: 'Emme voineet säilyttää kasvojasi muuttumattomina. Kokeile kuvaa suoraan edestä, jossa koko ylävartalo näkyy.',
    da: 'Vi kunne ikke bevare dit ansigt uændret i resultatet. Prøv et billede lige forfra, hvor hele overkroppen ses.',
    no: 'Vi klarte ikke å bevare ansiktet ditt uendret. Prøv et bilde rett forfra der hele overkroppen vises.',
    de: 'Wir konnten dein Gesicht im Ergebnis nicht unverändert lassen. Versuche ein Foto frontal, auf dem der ganze Oberkörper zu sehen ist.',
    fr: 'Nous n’avons pas pu conserver votre visage inchangé. Essayez une photo de face montrant tout le haut du corps.',
    es: 'No pudimos mantener tu cara sin cambios. Prueba una foto de frente que muestre todo el torso.',
    it: 'Non siamo riusciti a mantenere il tuo viso invariato. Prova una foto frontale che mostri tutto il busto.',
    nl: 'We konden je gezicht niet ongewijzigd houden. Probeer een foto recht van voren waarop je hele bovenlichaam zichtbaar is.',
  },
  try_on_err_input_deleted: {
    sv: 'Bilden raderades innan förhandsvisningen var klar. Ladda upp en ny bild för att försöka igen.',
    en: 'The photo was deleted before the preview was ready. Upload a new photo to try again.',
    fi: 'Kuva poistettiin ennen kuin esikatselu oli valmis. Lataa uusi kuva yrittääksesi uudelleen.',
    da: 'Billedet blev slettet, før forhåndsvisningen var klar. Upload et nyt billede for at prøve igen.',
    no: 'Bildet ble slettet før forhåndsvisningen var klar. Last opp et nytt bilde for å prøve igjen.',
    de: 'Das Foto wurde gelöscht, bevor die Vorschau fertig war. Lade ein neues Foto hoch, um es erneut zu versuchen.',
    fr: 'La photo a été supprimée avant que l’aperçu soit prêt. Téléchargez une nouvelle photo pour réessayer.',
    es: 'La foto se eliminó antes de que la vista previa estuviera lista. Sube una foto nueva para volver a intentarlo.',
    it: 'La foto è stata eliminata prima che l’anteprima fosse pronta. Carica una nuova foto per riprovare.',
    nl: 'De foto is verwijderd voordat de preview klaar was. Upload een nieuwe foto om het opnieuw te proberen.',
  },
  try_on_err_feet_not_visible: {
    sv: 'Bilden fungerar inte för skor. Ta en bild bara från knät och nedåt, framifrån eller från sidan, där båda skorna syns hela.',
    en: 'This photo does not work for shoes. Take a photo of just your legs from the knee down, from the front or the side, with both shoes fully visible.',
    fi: 'Kuva ei sovi kengille. Ota kuva vain polvista alaspäin, edestä tai sivulta, niin että molemmat kengät näkyvät kokonaan.',
    da: 'Billedet virker ikke til sko. Tag et billede kun fra knæet og ned, forfra eller fra siden, hvor begge sko ses helt.',
    no: 'Bildet fungerer ikke for sko. Ta et bilde bare fra kneet og ned, forfra eller fra siden, der begge skoene synes helt.',
    de: 'Dieses Foto eignet sich nicht für Schuhe. Mach ein Foto nur ab dem Knie abwärts, von vorn oder von der Seite, auf dem beide Schuhe vollständig zu sehen sind.',
    fr: 'Cette photo ne convient pas pour les chaussures. Prenez une photo du genou aux pieds uniquement, de face ou de côté, où les deux chaussures sont entièrement visibles.',
    es: 'Esta foto no sirve para zapatos. Haz una foto solo de la rodilla hacia abajo, de frente o de lado, en la que se vean los dos zapatos enteros.',
    it: 'Questa foto non va bene per le scarpe. Scatta una foto solo dal ginocchio in giù, di fronte o di lato, in cui entrambe le scarpe siano interamente visibili.',
    nl: 'Deze foto werkt niet voor schoenen. Maak een foto van alleen je benen vanaf de knie, van voren of van opzij, waarop beide schoenen volledig zichtbaar zijn.',
  },
  try_on_feet_your_photo: {
    sv: 'Din bild på fötterna', en: 'Your photo of your feet',
    fi: 'Kuva jaloistasi', da: 'Dit billede af fødderne',
    no: 'Ditt bilde av føttene', de: 'Dein Foto deiner Füße',
    fr: 'Votre photo de vos pieds', es: 'Tu foto de los pies',
    it: 'La tua foto dei piedi', nl: 'Je foto van je voeten',
  },
  try_on_feet_crop_title: {
    sv: 'Placera skorna i ramen', en: 'Position your shoes in the frame',
    fi: 'Aseta kengät kehykseen', da: 'Placér skoene i rammen',
    no: 'Plasser skoene i rammen', de: 'Positioniere die Schuhe im Rahmen',
    fr: 'Placez vos chaussures dans le cadre', es: 'Coloca los zapatos en el marco',
    it: 'Posiziona le scarpe nel riquadro', nl: 'Plaats je schoenen in het kader',
  },
  try_on_feet_crop_help: {
    sv: 'Dra tills båda skorna står i rutan längst ned. Ta bara med benen från knät och nedåt, inget ansikte.',
    en: 'Drag until both shoes sit in the box at the bottom. Include only your legs from the knee down, no face.',
    fi: 'Vedä, kunnes molemmat kengät ovat alalaidan ruudussa. Ota mukaan vain jalat polvesta alaspäin, ei kasvoja.',
    da: 'Træk, indtil begge sko står i feltet nederst. Tag kun benene med fra knæet og ned, intet ansigt.',
    no: 'Dra til begge skoene står i feltet nederst. Ta bare med bena fra kneet og ned, ikke ansiktet.',
    de: 'Ziehe, bis beide Schuhe im Feld unten stehen. Nur die Beine ab dem Knie abwärts, kein Gesicht.',
    fr: 'Faites glisser jusqu’à ce que les deux chaussures soient dans le cadre du bas. Seulement les jambes, du genou aux pieds, sans visage.',
    es: 'Arrastra hasta que ambos zapatos queden en el recuadro inferior. Solo las piernas de la rodilla hacia abajo, sin la cara.',
    it: 'Trascina finché entrambe le scarpe sono nel riquadro in basso. Solo le gambe dal ginocchio in giù, niente viso.',
    nl: 'Sleep tot beide schoenen in het vak onderaan staan. Alleen je benen vanaf de knie, geen gezicht.',
  },
  try_on_feet_tip_angle: {
    sv: 'Fota framifrån eller från sidan', en: 'Shoot from the front or the side',
    fi: 'Kuvaa edestä tai sivulta', da: 'Fotografér forfra eller fra siden',
    no: 'Ta bildet forfra eller fra siden', de: 'Fotografiere von vorn oder von der Seite',
    fr: 'Photographiez de face ou de côté', es: 'Haz la foto de frente o de lado',
    it: 'Scatta di fronte o di lato', nl: 'Fotografeer van voren of van opzij',
  },
  try_on_feet_tip_floor: {
    sv: 'Ställ telefonen på golvet mot en vägg och använd självutlösaren',
    en: 'Stand your phone on the floor against a wall and use the self-timer',
    fi: 'Aseta puhelin lattialle seinää vasten ja käytä ajastinta',
    da: 'Stil telefonen på gulvet op ad en væg og brug selvudløseren',
    no: 'Sett telefonen på gulvet mot en vegg og bruk selvutløseren',
    de: 'Stell das Handy auf den Boden an eine Wand und nutze den Selbstauslöser',
    fr: 'Posez votre téléphone au sol contre un mur et utilisez le retardateur',
    es: 'Apoya el móvil en el suelo contra una pared y usa el temporizador',
    it: 'Appoggia il telefono a terra contro una parete e usa l’autoscatto',
    nl: 'Zet je telefoon op de grond tegen een muur en gebruik de zelfontspanner',
  },
  try_on_feet_tip_visible: {
    sv: 'Båda skorna ska synas helt, från knät och nedåt', en: 'Both shoes fully visible, from the knee down',
    fi: 'Molempien kenkien tulee näkyä kokonaan, polvesta alaspäin', da: 'Begge sko skal ses helt, fra knæet og ned',
    no: 'Begge skoene må synes helt, fra kneet og ned', de: 'Beide Schuhe vollständig sichtbar, ab dem Knie abwärts',
    fr: 'Les deux chaussures entièrement visibles, du genou aux pieds', es: 'Ambos zapatos completamente visibles, de la rodilla hacia abajo',
    it: 'Entrambe le scarpe ben visibili, dal ginocchio in giù', nl: 'Beide schoenen volledig zichtbaar, vanaf de knie naar beneden',
  },
  try_on_feet_disclaimer: {
    sv: 'Bilden visar hur skon ser ut på dig, inte storlek eller passform.',
    en: 'The image shows how the shoe looks on you, not its size or fit.',
    fi: 'Kuva näyttää, miltä kenkä näyttää jalassasi, ei kokoa tai istuvuutta.',
    da: 'Billedet viser, hvordan skoen ser ud på dig, ikke størrelse eller pasform.',
    no: 'Bildet viser hvordan skoen ser ut på deg, ikke størrelse eller passform.',
    de: 'Das Bild zeigt, wie der Schuh an dir aussieht, nicht Größe oder Passform.',
    fr: 'L’image montre l’allure de la chaussure sur vous, pas sa taille ni son ajustement.',
    es: 'La imagen muestra cómo se ve el zapato en ti, no la talla ni el ajuste.',
    it: 'L’immagine mostra come ti sta la scarpa, non la taglia né la vestibilità.',
    nl: 'De afbeelding laat zien hoe de schoen er bij jou uitziet, niet de maat of pasvorm.',
  },
} as const;

type StringKey = keyof typeof STRINGS;

export function t(key: StringKey, lang?: string): string {
  const map = STRINGS[key] as Record<string, string>;
  return map[lang ?? ''] ?? map['sv'];
}
